var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/privacy-dropdown.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import { supportsPassiveEvents } from 'detect-passive-events';
import React, { useState, useRef, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { spring } from 'react-motion'; // @ts-ignore

import Overlay from 'react-overlays/lib/Overlay';
import { changeComposeVisibility } from 'soapbox/actions/compose';
import { closeModal, openModal } from 'soapbox/actions/modals';
import Icon from 'soapbox/components/icon';
import { IconButton } from 'soapbox/components/ui';
import { useAppDispatch, useCompose } from 'soapbox/hooks';
import { isUserTouching } from 'soapbox/is-mobile';
import Motion from '../../ui/util/optional-motion';
const messages = defineMessages({
  public_short: {
    "id": "privacy.public.short",
    "defaultMessage": "Public"
  },
  public_long: {
    "id": "privacy.public.long",
    "defaultMessage": "Post to public timelines"
  },
  unlisted_short: {
    "id": "privacy.unlisted.short",
    "defaultMessage": "Unlisted"
  },
  unlisted_long: {
    "id": "privacy.unlisted.long",
    "defaultMessage": "Do not post to public timelines"
  },
  private_short: {
    "id": "privacy.private.short",
    "defaultMessage": "Followers-only"
  },
  private_long: {
    "id": "privacy.private.long",
    "defaultMessage": "Post to followers only"
  },
  direct_short: {
    "id": "privacy.direct.short",
    "defaultMessage": "Direct"
  },
  direct_long: {
    "id": "privacy.direct.long",
    "defaultMessage": "Post to mentioned users only"
  },
  change_privacy: {
    "id": "privacy.change",
    "defaultMessage": "Adjust post privacy"
  }
});
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;

const PrivacyDropdownMenu = _ref => {
  let {
    style,
    items,
    placement,
    value,
    onClose,
    onChange
  } = _ref;
  const node = useRef(null);
  const focusedItem = useRef(null);
  const [mounted, setMounted] = useState(false);

  const handleDocumentClick = e => {
    if (node.current && !node.current.contains(e.target)) {
      onClose();
    }
  };

  const handleKeyDown = e => {
    var _node$current, _node$current2, _node$current3, _node$current4, _node$current9, _node$current10;

    const value = e.currentTarget.getAttribute('data-index');
    const index = items.findIndex(item => item.value === value);
    let element = null;

    switch (e.key) {
      case 'Escape':
        onClose();
        break;

      case 'Enter':
        handleClick(e);
        break;

      case 'ArrowDown':
        element = ((_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.childNodes[index + 1]) || ((_node$current2 = node.current) === null || _node$current2 === void 0 ? void 0 : _node$current2.firstChild);
        break;

      case 'ArrowUp':
        element = ((_node$current3 = node.current) === null || _node$current3 === void 0 ? void 0 : _node$current3.childNodes[index - 1]) || ((_node$current4 = node.current) === null || _node$current4 === void 0 ? void 0 : _node$current4.lastChild);
        break;

      case 'Tab':
        if (e.shiftKey) {
          var _node$current5, _node$current6;

          element = ((_node$current5 = node.current) === null || _node$current5 === void 0 ? void 0 : _node$current5.childNodes[index - 1]) || ((_node$current6 = node.current) === null || _node$current6 === void 0 ? void 0 : _node$current6.lastChild);
        } else {
          var _node$current7, _node$current8;

          element = ((_node$current7 = node.current) === null || _node$current7 === void 0 ? void 0 : _node$current7.childNodes[index + 1]) || ((_node$current8 = node.current) === null || _node$current8 === void 0 ? void 0 : _node$current8.firstChild);
        }

        break;

      case 'Home':
        element = (_node$current9 = node.current) === null || _node$current9 === void 0 ? void 0 : _node$current9.firstChild;
        break;

      case 'End':
        element = (_node$current10 = node.current) === null || _node$current10 === void 0 ? void 0 : _node$current10.lastChild;
        break;
    }

    if (element) {
      element.focus();
      onChange(element.getAttribute('data-index'));
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleClick = e => {
    var _e$currentTarget;

    const value = (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.getAttribute('data-index');
    e.preventDefault();
    onClose();
    onChange(value);
  };

  useEffect(() => {
    var _focusedItem$current;

    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, listenerOptions);
    (_focusedItem$current = focusedItem.current) === null || _focusedItem$current === void 0 ? void 0 : _focusedItem$current.focus({
      preventScroll: true
    });
    setMounted(true);
    return () => {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('touchend', handleDocumentClick);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      opacity: 0,
      scaleX: 0.85,
      scaleY: 0.75
    },
    style: {
      opacity: spring(1, {
        damping: 35,
        stiffness: 400
      }),
      scaleX: spring(1, {
        damping: 35,
        stiffness: 400
      }),
      scaleY: spring(1, {
        damping: 35,
        stiffness: 400
      })
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 5
    }
  }, _ref2 => {
    let {
      opacity,
      scaleX,
      scaleY
    } = _ref2;
    return (
      /*#__PURE__*/
      // It should not be transformed when mounting because the resulting
      // size will be used to determine the coordinate of the menu by
      // react-overlays
      React.createElement("div", {
        className: "privacy-dropdown__dropdown ".concat(placement),
        style: _objectSpread(_objectSpread({}, style), {}, {
          opacity: opacity,
          transform: mounted ? "scale(".concat(scaleX, ", ").concat(scaleY, ")") : undefined
        }),
        role: "listbox",
        ref: node,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 123,
          columnNumber: 9
        }
      }, items.map(item => /*#__PURE__*/React.createElement("div", {
        role: "option",
        tabIndex: 0,
        key: item.value,
        "data-index": item.value,
        onKeyDown: handleKeyDown,
        onClick: handleClick,
        className: classNames('privacy-dropdown__option', {
          active: item.value === value
        }),
        "aria-selected": item.value === value,
        ref: item.value === value ? focusedItem : null,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "privacy-dropdown__option__icon",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: item.icon,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 17
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "privacy-dropdown__option__content",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement("strong", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131,
          columnNumber: 17
        }
      }, item.text), item.meta))))
    );
  });
};

const PrivacyDropdown = _ref3 => {
  let {
    composeId
  } = _ref3;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const node = useRef(null);
  const activeElement = useRef(null);
  const compose = useCompose(composeId);
  const value = compose.privacy;
  const unavailable = compose.id;
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('bottom');
  const options = [{
    icon: require('@tabler/icons/world.svg'),
    value: 'public',
    text: intl.formatMessage(messages.public_short),
    meta: intl.formatMessage(messages.public_long)
  }, {
    icon: require('@tabler/icons/lock-open.svg'),
    value: 'unlisted',
    text: intl.formatMessage(messages.unlisted_short),
    meta: intl.formatMessage(messages.unlisted_long)
  }, {
    icon: require('@tabler/icons/lock.svg'),
    value: 'private',
    text: intl.formatMessage(messages.private_short),
    meta: intl.formatMessage(messages.private_long)
  }, {
    icon: require('@tabler/icons/mail.svg'),
    value: 'direct',
    text: intl.formatMessage(messages.direct_short),
    meta: intl.formatMessage(messages.direct_long)
  }];

  const onChange = value => value && dispatch(changeComposeVisibility(composeId, value));

  const onModalOpen = props => dispatch(openModal('ACTIONS', props));

  const onModalClose = () => dispatch(closeModal('ACTIONS'));

  const handleToggle = e => {
    if (isUserTouching()) {
      if (open) {
        onModalClose();
      } else {
        onModalOpen({
          actions: options.map(option => _objectSpread(_objectSpread({}, option), {}, {
            active: option.value === value
          })),
          onClick: handleModalActionClick
        });
      }
    } else {
      const {
        top
      } = e.currentTarget.getBoundingClientRect();

      if (open) {
        var _activeElement$curren;

        (_activeElement$curren = activeElement.current) === null || _activeElement$curren === void 0 ? void 0 : _activeElement$curren.focus();
      }

      setPlacement(top * 2 < innerHeight ? 'bottom' : 'top');
      setOpen(!open);
    }

    e.stopPropagation();
  };

  const handleModalActionClick = e => {
    e.preventDefault();
    const {
      value
    } = options[e.currentTarget.getAttribute('data-index')];
    onModalClose();
    onChange(value);
  };

  const handleKeyDown = e => {
    switch (e.key) {
      case 'Escape':
        handleClose();
        break;
    }
  };

  const handleMouseDown = () => {
    if (!open) {
      activeElement.current = document.activeElement;
    }
  };

  const handleButtonKeyDown = e => {
    switch (e.key) {
      case ' ':
      case 'Enter':
        handleMouseDown();
        break;
    }
  };

  const handleClose = () => {
    if (open) {
      var _activeElement$curren2;

      (_activeElement$curren2 = activeElement.current) === null || _activeElement$curren2 === void 0 ? void 0 : _activeElement$curren2.focus();
    }

    setOpen(false);
  };

  if (unavailable) {
    return null;
  }

  const valueOption = options.find(item => item.value === value);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('privacy-dropdown', placement, {
      active: open
    }),
    onKeyDown: handleKeyDown,
    ref: node,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 242,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('privacy-dropdown__value', {
      active: valueOption && options.indexOf(valueOption) === 0
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "text-gray-600 hover:text-gray-700 dark:hover:text-gray-500",
    src: valueOption === null || valueOption === void 0 ? void 0 : valueOption.icon,
    title: intl.formatMessage(messages.change_privacy),
    onClick: handleToggle,
    onMouseDown: handleMouseDown,
    onKeyDown: handleButtonKeyDown,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 244,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Overlay, {
    show: open,
    placement: placement,
    target: node.current,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 254,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(PrivacyDropdownMenu, {
    items: options,
    value: value,
    onClose: handleClose,
    onChange: onChange,
    placement: placement,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 255,
      columnNumber: 9
    }
  })));
};

export default PrivacyDropdown;